// extracted by mini-css-extract-plugin
export default {"imageState":"ProductImage_imageState__vPRVu","imageSpinner":"ProductImage_imageSpinner__1SFgb","spin":"ProductImage_spin__2h7RH"};